<app-header-component (toggle)="toggleDrawer(drawer)" [selectedPage]="selected"></app-header-component>
<kendo-drawer-container>
    <kendo-drawer #drawer [items]="items" [mode]="mode" [mini]="mini" [autoCollapse]="false" [expanded]="expanded"
        [animation]="true" (select)="onSelect($event,drawer)">
    </kendo-drawer>
    <!-- [isItemExpanded]="isItemExpanded" -->
    <kendo-drawer-content>

        <router-outlet>
        </router-outlet>
    </kendo-drawer-content>
</kendo-drawer-container>
<!-- <div class="footer footer-bg"></div> -->